package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.error.ValidationError
import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.model.GameEvent
import fr.manyverse.app.domain.repository.GameEventRepository

class SendMessageUseCase(private val gameEventRepository: GameEventRepository) {
    suspend operator fun invoke(
        tableId: String,
        senderId: String,
        senderName: String,
        recipientIds: List<String>,
        text: String
    ): Result<GameEvent> {
        if (text.isBlank()) {
            return Result.failure(ValidationError("Message text cannot be empty"))
        }
        if (recipientIds.isEmpty()) {
            return Result.failure(ValidationError("Recipient list cannot be empty"))
        }
        return gameEventRepository.createEvent(
            tableId = tableId,
            type = EventType.MESSAGE_SENT,
            triggeredBy = senderId,
            targetParticipants = recipientIds,
            content = EventContent.MessageSent(text = text.trim(), senderName = senderName)
        )
    }
}
